module.exports = __webpack_public_path__ + "img/revdojo_logo.50424469.png";